export {}

declare global {
  interface String {
    ucfirst(): string

    toValidUrl(): string
  }

  interface Array<T> {
    take(count: number): T[]

    takeLast(count: number): T[]
  }

  interface Date {
    format(format: string): string
  }
}

// eslint-disable-next-line no-extend-native
String.prototype.ucfirst = function (): string {
  return this.charAt(0).toUpperCase() + this.slice(1)
}

// eslint-disable-next-line no-extend-native
String.prototype.toValidUrl = function (): string {
  let url = this.split('//')
    .filter((e) => e)
    .join('//')

  if (url.slice(-1) !== '/') {
    url = `${url}/`
  }

  return url
}

// eslint-disable-next-line no-extend-native
Array.prototype.take = function <T>(this: T[], count: number): T[] {
  return this.slice(0, count)
}

// eslint-disable-next-line no-extend-native
Array.prototype.takeLast = function <T>(this: T[], count: number): T[] {
  return this.slice(this.length - count, this.length)
}

// eslint-disable-next-line no-extend-native
Date.prototype.format = function (format: string): string {
  const map: { [key: string]: string } = {
    Y: this.getFullYear().toString(),
    m: ('0' + (this.getMonth() + 1)).slice(-2),
    d: ('0' + this.getDate()).slice(-2),
    H: ('0' + this.getHours()).slice(-2),
    i: ('0' + this.getMinutes()).slice(-2),
    s: ('0' + this.getSeconds()).slice(-2)
  }

  return format.replace(/Y|m|d|H|i|s/g, (matched) => map[matched])
}
